/**
 * Takes a field label and converts it to lowercase, replaces spaces with underscores,
 * removes asterisks and colons, and trims whitespace.
 *
 * @param fieldLabel The field label to format.
 * @returns string The formatted field label.
 */
const cleanFieldLabel = (fieldLabel) => {
	if (!fieldLabel) {
		return fieldLabel;
	}

	return fieldLabel
		.trim()
		.replace(/ /g, '_')
		.replace(/\*/, '')
		.replace(/:/, '')
		.toLowerCase();
};

export default cleanFieldLabel;
